<div class="page-header clearfix">
  <h1 class="page-header__title">Alerts</h1>
</div>
<div class="container-fluid">
  <div class="row pt-3">
    <div class="col-lg-12">
      <div class="empty-state" *ngIf="emptyProject">
        <h1>We haven't received any alert activity from this project yet</h1>
      </div>
      <div *ngIf="!emptyProject && alerts?.length > 0">
        <div class="alerts-table__pager">
          {{ alertCount }} {{ alertCount | pluralize: "Alert" }}, Page
          {{ page }} of {{ totalPages }} &nbsp;<span class="btn-group">
            <button
              class="btn"
              type="button"
              (click)="loadPrevPage()"
              [disabled]="!hasPrevPage()"
            >
              <i class="glyphicon glyphicon-angle-left"></i>
            </button>
            <button
              class="btn"
              type="button"
              (click)="loadNextPage()"
              [disabled]="!hasNextPage()"
            >
              <i class="glyphicon glyphicon-angle-right"></i></button
          ></span>
        </div>
        <table class="ab-table">
          <colgroup>
            <col style="width: 5%" />
            <col style="width: 9%" />
            <col style="width: 21%" />
            <col style="width: 20%" />
            <col style="width: 5%" />
            <col style="width: 40%" />
          </colgroup>
          <thead>
            <th class="ab-table__header">When</th>
            <th class="ab-table__header">UTC</th>
            <th class="ab-table__header">Route</th>
            <th class="ab-table__header">Metric change</th>
            <th class="ab-table__header">Severity</th>
            <th class="ab-table__header">Duration</th>
          </thead>
          <thead>
            <th class="ab-table__header"></th>
            <th class="ab-table__header"></th>
            <th class="ab-table__header">
              <input
                class="color--grey-400"
                type="text"
                placeholder="Filter routes"
                [(ngModel)]="search"
              />
            </th>
            <th class="ab-table__header">
              <span class="alerts__no-text-transform" ngbDropdown="ngbDropdown">
                <button
                  class="btn btn-sm"
                  ngbDropdownToggle="ngbDropdownToggle"
                  container="body"
                  type="button"
                >
                  {{ currentMetricOption.text }}
                </button>
                <ul
                  class="dropdown-menu--reduced-padding"
                  ngbDropdownMenu="ngbDropdownMenu"
                >
                  <li
                    *ngFor="let option of metricOptions; trackBy: trackByIndex"
                  >
                    <a
                      (click)="selectMetricOption(option)"
                      ngbDropdownItem="ngbDropdownItem"
                      ><i
                        class="list-icon glyphicon"
                        [ngClass]="{
                          'glyphicon-check':
                            option.text === currentMetricOption.text
                        }"
                      ></i
                      >{{ option.text }}</a
                    >
                  </li>
                </ul></span
              >
            </th>
            <th class="ab-table__header"></th>
            <th class="ab-table__header"></th>
          </thead>
          <tbody>
            <tr
              class="ab-table__row"
              *ngFor="
                let alert of alerts
                  | alertFilter: 'route':search
                  | alertFilter: 'metric':currentMetricOption.metric
                  | alertFilter: 'statusClass':currentMetricOption.statusClass;
                index as i;
                trackBy: trackBy
              "
              [ngClass]="{
                'ab-table__row--no-border':
                  (alerts[i - 1]?.params.time | date: 'dd') ===
                  (alert.params.time | date: 'dd')
              }"
            >
              <td class="ab-table__cell">
                <span
                  *ngIf="
                    (alerts[i - 1]?.params.time | date: 'dd') !==
                    (alert.params.time | date: 'dd')
                  "
                  >{{ alert?.params.time | date: "MMM dd":"UTC" }}</span
                >
              </td>
              <td class="ab-table__cell">
                <span *ngIf="alert.params.endTime"
                  >{{ alert?.params.time | date: "HH:mm a":"UTC" }}&ndash;{{
                    alert?.params.endTime | date: "HH:mm a":"UTC"
                  }}</span
                ><span class="color--danger" *ngIf="!alert.params.endTime"
                  >{{
                    alert?.params.time | date: "HH:mm a":"UTC"
                  }}&ndash;ongoing</span
                >
              </td>
              <td class="ab-table__cell">
                <a
                  uiSref="routes-show"
                  [uiParams]="{ routeId: alert.trackableId }"
                >
                  <ab-route-method
                    [method]="alert.params.method"
                  ></ab-route-method
                  >&nbsp;
                  <ab-route-name
                    [routeName]="alert.params.route"
                  ></ab-route-name
                ></a>
              </td>
              <td class="ab-table__cell">
                <span class="alerts-metric">
                  <ab-env-label [env]="alert | alertMetric"></ab-env-label
                  >&nbsp;<span
                    *ngIf="activityKind(alert) === 'timing'"
                    [ngClass]="{
                      'alerts-metric__spike': alert.params.alarmType === 'drop',
                      'alerts-metric__drop': alert.params.alarmType === 'spike'
                    }"
                    >{{ alert.params.mean.toFixed(2) }}</span
                  ><span
                    *ngIf="activityKind(alert) === 'requests'"
                    [ngClass]="{
                      'alerts-metric__spike': alert.params.alarmType === 'drop',
                      'alerts-metric__drop': alert.params.alarmType === 'spike'
                    }"
                    >{{ alert.params.mean | number: "1.0-0" }}</span
                  ><span
                    *ngIf="activityKind(alert) === 'ratio'"
                    [ngClass]="{
                      'alerts-metric__spike': alert.params.alarmType === 'drop',
                      'alerts-metric__drop': alert.params.alarmType === 'spike'
                    }"
                    >{{ alert.params.mean * 100 | number: "1.0-0" }}</span
                  ><span *ngIf="alert.params.alarmType === 'spike'">&#8599;</span
                  ><span *ngIf="alert.params.alarmType === 'drop'">&#8600;</span
                  ><span
                    *ngIf="activityKind(alert) === 'timing'"
                    [ngClass]="{
                      'alerts-metric__spike': alert.params.alarmType === 'spike',
                      'alerts-metric__drop': alert.params.alarmType === 'drop'
                    }"
                    >{{ alert.params.value.toFixed(2) }}</span
                  ><span
                    *ngIf="activityKind(alert) === 'requests'"
                    [ngClass]="{
                      'alerts-metric__spike': alert.params.alarmType === 'spike',
                      'alerts-metric__drop': alert.params.alarmType === 'drop'
                    }"
                    >{{ alert.params.value | number: "1.0-0" }}</span
                  ><span
                    *ngIf="activityKind(alert) === 'ratio'"
                    [ngClass]="{
                      'alerts-metric__spike': alert.params.alarmType === 'spike',
                      'alerts-metric__drop': alert.params.alarmType === 'drop'
                    }"
                    >{{ alert.params.value * 100 | number: "1.0-0" }}</span
                  >&nbsp; {{ alert.params.unit }}</span
                >
              </td>
              <td class="ab-table__cell">
                <ab-env-label [env]="alert | alertSeverity"></ab-env-label>
              </td>
              <td class="ab-table__cell">
                <div class="text-small alerts-duration__text">
                  {{ alert | alertDuration }}
                </div>
                <div
                  class="alerts-duration"
                  [ngStyle]="{ width: (alert | alertDurationPct) + '%' }"
                ></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
